import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import authUtils from '../../auth/utils';
import { withTranslation } from 'react-i18next';
import List from '../individualConsultationForms/List';
import { deleteIndividualConsultationFormResponse, loadIndividualConsultationFormResponsesByChild } from '../individualConsultationForms/actions';

class ChildFormList extends Component {
	constructor(props) {
		super(props);
		this.handleListEvent = this.handleListEvent.bind(this);
		this.handleDeleteFormResponse = this.handleDeleteFormResponse.bind(this);
	}

	componentDidMount() {
		this.loadListData(this.props.childId, { pageNumber: 1, pageSize: this.props.pagination.pageSize });
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.childId !== this.props.childId) {
			this.loadListData(nextProps.childId, { ...nextProps.pagination });
		}
	}

	loadListData(childId, { sortKey = 'date', sortDirection = 'desc', pageNumber, pageSize }) {
		if (childId) {
			this.props.loadByChild({ childId, sortKey, sortDirection, pageSize, pageNumber });
		}
	}

	handleListEvent(listPagination) {
		this.loadListData(this.props.childId, { ...listPagination });
	}

	handleDeleteFormResponse(id) {
		this.props.deleteFormResponse(id, () => this.loadListData(this.props.childId, { ...this.props.pagination }));
	}

	render() {
		const { isReadonly, data, pagination, allowDeleteCompleted, t, ...rest } = this.props;

		return <div>
			<List onFetchData={this.handleListEvent} data={data} onDelete={this.handleDeleteFormResponse} allowDeleteCompleted={allowDeleteCompleted}  {...pagination} {...rest} />
		</div>;
	}
}

const mapStateToProps = (state, ownProps) => {
	const childId = ownProps.childId;
	const {
		pagination,
		entities: { individualConsultationFormResponses },
		auth: { currentUser }
	} = state;

	const individualConsultationFormResponsesPagination = pagination.individualConsultationChildFormResponses[childId] || { ids: [], pageNumber: 1, pageSize: 10 };

	return {
		data: individualConsultationFormResponsesPagination.ids.map(id => individualConsultationFormResponses[id]),
		pagination: individualConsultationFormResponsesPagination,
		isReadonly: authUtils.hasReadOnlyPermission(currentUser, 'IndividualConsultationDocuments'),
		allowDeleteCompleted: authUtils.hasPermission(currentUser, 'UndoCompletedForms'),
		childId
	};
};
ChildFormList.propTypes = {
	childId: PropTypes.number.isRequired
};

export default connect(mapStateToProps, {
	loadByChild: loadIndividualConsultationFormResponsesByChild,
	deleteFormResponse: deleteIndividualConsultationFormResponse
})(withTranslation()(ChildFormList));